import type { OptionsMap } from '@openx/types/options';
import type { Section } from '../context/types';

export const filterOptions = (initialState: Section, apiOptionsMap: OptionsMap): Section => {
  const allowedKeys = new Set(Object.keys(apiOptionsMap));

  return {
    ...initialState,
    elements: initialState.elements
      .filter(element => allowedKeys.has(element.mainOption.key))
      .map(element => ({
        ...element,
        subOptions: element.subOptions?.filter(sub => allowedKeys.has(sub.key)),
      })),
  };
};
